import { render, staticRenderFns } from "./ImportHistory.vue?vue&type=template&id=3669e0a0&"
import script from "./ImportHistory.vue?vue&type=script&lang=js&"
export * from "./ImportHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImportHistory.vue"
export default component.exports